module.exports = __webpack_public_path__ + "img/live-tracking.4ebfc861.png";